export const LOGGING_ENDPOINTS = {
    SESSION_LOGS: '/kiosk-logs/session-logs',
    MENU_LOGS: '/kiosk-logs/menu-logs',
    POI_LOGS: '/kiosk-logs/poi-logs',
    KEYWORD_LOGS: '/kiosk-logs/keyword-logs',
    LANGUAGE_LOGS: '/kiosk-logs/language-logs',
    NAVIGATION_LOGS: '/kiosk-logs/navigation-logs',
};
